import React, { useState } from 'react';
import styled from 'styled-components';
import { Img, Icon, Button } from 'components';
import { Section, Box, Text } from 'styles';

export function Section9(props) {
  const [isB2B, setIsB2B] = useState(true);
  const handleToggle = () => {
    setIsB2B(!isB2B);
  };

  // issue#12326: implement scroll to request
  return (
    <Section style={{ backgroundColor: '#1A1A2E'}}>
      <Box $maxWidth={1600} 
          $width="100%"
          $padding="80px 40px"
          $mPadding="40px 20px"
          $margin="auto"
          $textAlign="left">
        <Box>
          <Button $type="badge" $color="orange">
            <Icon name="badgeIcon" />
            Who's using it?
          </Button>
        </Box>
        <Text $type="b40" $mType="b28" $padding="24px 0" $color="white">
          B2B부터 B2C까지
          <br />
          N-Survey 하나로
        </Text>
        <Text $type="18" $mType="16" $color="gray600">
          데이터가 필요한 기업과 설문 참여로 보상을 받는 응답자를 연결합니다.
        </Text>
        <Box $margin="auto" $padding="36px 0" $mPadding="8px 0" $maxWidth={1600}>
          <Button onClick={handleToggle} style={{ padding: '0px', backgroundColor: 'transparent'}}>
            <ResponsiveIcon name={isB2B ? "toggleLeft" : "toggleRight"} />
          </Button>
          <Box $padding="36px 0" $mPadding="16px 0">
            <Img $width="100%"
                 desktopSrc={isB2B ? "mainB2B" : "mainB2C"}
                 mobileSrc={isB2B ? "moMainB2B" : "moMainB2C"}
            />
          </Box>
        </Box>
      </Box>
    </Section>
  );
}

const ResponsiveIcon = styled(Icon)`
  @media ${({ theme }) => theme.device.mobile} {
    svg {
      width: 100% !important;
    }
  }
`;

